import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DashboardService } from "src/app/core/services/dashboard.service";
import { SuiteService } from "src/app/core/services/suite.service";
import { DataIngestionService } from "src/app/core/services/dataIngestion.service";

@Component({
  selector: "app-report-pack-filter",
  templateUrl: "./report-pack-filter.component.html",
  styleUrls: ["./report-pack-filter.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ReportPackFilterComponent implements OnInit, OnChanges, OnDestroy {
  modalRef: NgbModalRef | null = null;
  @Input() selectedReportPacks: any;
  @Input() selectedRpIds: any;
  @Input() resetSelectionToken: number = 0;
  @Input() ingestionDataTypes: any = [];
  @Input() rpIdsToIgnore: any = [];
  @Input() updateServiceOnRpSelection: boolean = true;
  @Input() showOnlyValidReportPacks: boolean = true;
  @Input() reportPackList: any;
  @Input() selectionMode: "single" | "multiple" = "single";
  @Output() selectedReportPacksChange = new EventEmitter();

  reportPacks: any;
  suite: string;
  selectedRpRows: any;
  loading = false;
  isReport = false;
  headerCols: any[];
  reportDateFilters: Date[];
  ingestedDateFilters: Date[];
  private dateTime = new Date();
  private yearRange = "2000:" + this.dateTime.getFullYear().toString();
  showDescription: boolean;
  rpForBannerDisplay: any;

  constructor(
    private modalService: NgbModal,
    private dashboardService: DashboardService,
    private dataIngestionService: DataIngestionService,
    private suiteService: SuiteService,
    private cdr: ChangeDetectorRef,
    ) {
  }

  ngOnInit() {
    this.headerCols = [
      { field: "ReportPackID", header: "Report Pack ID" },
      { field: "Title", header: "Report Pack Title" },
      { field: "RP_Description", header: "Description" },
      { field: "ReportDate", header: "Report Date" },
      {
        field: "DefaultRPSequenceName",
        header: "Default Report Pack Sequence",
      },
      { field: "IngestedBy", header: "Ingested By" },
      { field: "IngestedDate", header: "Ingested Date" },
    ];

    if (this.reportPackList) {
      this.prepareDisplayList();
    } else if (this.showOnlyValidReportPacks) {
      this.loading = true;
      this.dashboardService.getReportPacks().then(
        () => {
          this.reportPacks = JSON.parse(
            JSON.stringify(this.dashboardService.reportPackIdList)
          );
          this.reportPackList = this.dashboardService.reportPackIdList;
          this.prepareDisplayList();
          this.loading = false;
          this.cdr.detectChanges();
        },
        () => {
          this.loading = false;
          this.cdr.detectChanges();
        }
      );
    } else {
      this.loading = true;
      this.dataIngestionService.getReportPacks().then(
        (data: any) => {
          this.reportPacks = JSON.parse(JSON.stringify(data));
          this.reportPackList = data;
          this.prepareDisplayList();
          this.loading = false;
          this.cdr.detectChanges();
        },
        () => {
          this.loading = false;
          this.cdr.detectChanges();
        }
      );
    }

    this.suite = this.suiteService.getCurrentSuite();
    if (this.suite != null) {
      this.dashboardService.getSuiteReports(this.suite);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.hasOwnProperty("resetSelectionToken") &&
      !changes.resetSelectionToken.firstChange
    ) {
      this.selectedRpRows = null;
      this.selectedReportPacks = null;
      this.rpForBannerDisplay = null;
      this.clearFilters();
      this.selectedReportPacksChange.emit(this.selectedReportPacks);
      return;
    }

    if (
      (changes.hasOwnProperty("reportPackList") &&
        this.reportPackList &&
        this.reportPackList.length > 0) ||
      (changes.hasOwnProperty("selectedRpIds") && this.selectedRpIds) ||
      (changes.hasOwnProperty("rpIdsToIgnore") && this.rpIdsToIgnore) ||
      (changes.hasOwnProperty("selectedReportPacks") &&
        this.selectedReportPacks) ||
      (changes.hasOwnProperty("ingestionDataTypes") &&
        this.ingestionDataTypes &&
        this.ingestionDataTypes.length > 0)
    ) {
      this.reportPackList = JSON.parse(JSON.stringify(this.reportPacks));
      this.prepareDisplayList();
    }
  }

  ngOnDestroy(): void {
     if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
        }
  }

  dateRangeFilter(value: any, filter: [Date, Date]): boolean {
    if (!filter || (!filter[0] && !filter[1])) return true;
    const val = new Date(value);
    const s = filter[0].getTime();
    let e;
    if (filter[1]) e = filter[1].getTime() + 24 * 60 * 60 * 1000 - 1000;
    else e = s + 24 * 60 * 60 * 1000 - 1000;
    return val.getTime() >= s && val.getTime() <= e;
  }

  prepareDisplayList() {
    if (this.ingestionDataTypes && this.ingestionDataTypes.length > 0) {
      this.reportPackList = this.reportPackList.filter(
        (x) =>
          x.DataTypes.filter((y) => this.ingestionDataTypes.indexOf(y) > -1)
            .length > 0
      );
    }
    if (this.rpIdsToIgnore && this.rpIdsToIgnore.length > 0) {
      this.reportPackList = this.reportPackList.filter(
        (x) => this.rpIdsToIgnore.indexOf(x.ReportPackID) === -1
      );
    }
    if (this.selectedReportPacks) {
      this.selectedRpRows = this.selectedReportPacks;
    } else if (
      this.updateServiceOnRpSelection &&
      this.reportPackList.length > 0 &&
      this.dashboardService.reportPackID &&
      this.reportPackList.filter(
        (x) => x.ReportPackID == this.dashboardService.reportPackID
      ).length > 0
    ) {
      this.selectedReportPacks = this.reportPackList.filter(
        (x) => x.ReportPackID == this.dashboardService.reportPackID
      );
      this.selectedRpRows = this.selectedReportPacks;
    } else if (
      this.selectedRpIds &&
      this.reportPackList.length > 0 &&
      this.reportPackList.filter((x) =>
        Array.isArray(this.selectedRpIds)
          ? this.selectedRpIds.indexOf(x.ReportPackID) > -1
          : x.ReportPackID == this.selectedRpIds
      ).length > 0
    ) {
      this.selectedReportPacks = this.reportPackList.filter((x) =>
        Array.isArray(this.selectedRpIds)
          ? this.selectedRpIds.indexOf(x.ReportPackID) > -1
          : x.ReportPackID == this.selectedRpIds
      );
      this.selectedRpRows = this.selectedReportPacks;
    }
    if (this.selectionMode == "single" && this.selectedReportPacks)
      this.rpForBannerDisplay = Array.isArray(this.selectedReportPacks)
        ? this.selectedReportPacks[0]
        : this.selectedReportPacks;
  }

  closeDateRangeFilter(dateComponent: any, filters: Date[]) {
    if (filters[1]) {
      dateComponent.hideOverlay();
    }
  }

  clearFilters() {
    this.ingestedDateFilters = null;
    this.reportDateFilters = null;
  }

  /**
   * Sets report pack id
   */
  async setReportPackId() {
    this.closeModal();
    this.selectedReportPacks = this.selectedRpRows;
    if (this.selectionMode == "single")
      this.rpForBannerDisplay = this.selectedReportPacks;
    if (this.updateServiceOnRpSelection && this.selectionMode == "single") {
      this.dashboardService.setReportPack(this.selectedRpRows);
    }
    this.selectedReportPacksChange.emit(this.selectedReportPacks);
  }

  open(reportPackFilter) {
    
     this.modalRef = this.modalService.open(reportPackFilter, {
            size: 'xl',
            windowClass: 'animated fadeInDown fast',
            scrollable: true,
            backdrop: false
        });
  }

  openModal(descriptionContent) {
    this.modalRef = this.modalService.open(descriptionContent, {
            windowClass: 'animated fadeInDown fast',
            scrollable: true,
            backdrop: false
        });
  }

  closeModal() {
     this.clearFilters();
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
        }
  }

  overflowToolCheck() {
    let ele = document.getElementById("overflowCheck");
    let osw = ele.offsetWidth;
    let sw = ele.scrollWidth;

    if (osw < sw) {
      this.showDescription = true;
    } else {
      this.showDescription = false;
    }
  }
}
